import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PublicLayout from '../components/PublicLayout';
import { getSubscriptionPlans } from '../config/subscriptionPlans';
import styles from './Pricing.module.css';

const Pricing = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const subscriptionPlans = getSubscriptionPlans();

  const handleSignUp = (plan) => {
    // Navigate to signup page with selected plan
    navigate('/signup', { state: { selectedPlan: plan } });
  };

  const handleGetStarted = () => {
    // Navigate to signup page
    navigate('/signup');
  };

  const handleContactUs = () => {
    // Navigate to contact page with Team License state
    navigate('/contact', { state: { teamLicense: true } });
  };

  return (
    <PublicLayout>
      <div className={styles.pricingPage}>
        <div className={styles.pricingContainer}>
        {/* Header */}
        <div className={styles.pricingHeader}>
          <h1>Subscription Packages</h1>
          <p>Choose the perfect plan for your real estate business</p>
        </div>

        {/* Subscription Plans */}
        <div className={styles.plansGrid}>
          {subscriptionPlans
            .filter(plan => plan.key !== 'skyscraper')
            .map((plan) => (
            <div key={plan.key} className={styles.planCard}>
              <div className={styles.planHeader}>
                <h3>{plan.name}</h3>
                <p className={styles.planDescription}>{plan.description}</p>
                <div className={styles.planPrice}>
                  {plan.key === 'foundation' ? (
                    <>
                      <div className={styles.originalPrice}>${plan.price}/month</div>
                      <div>
                        <span className={styles.price}>${(plan.price / 2).toFixed(2)}</span>
                        <span className={styles.period}>first month</span>
                      </div>
                      <p className={styles.promoNote}>
                        50% off first month
                        <span>Use <strong>VATES50</strong> at checkout</span>
                      </p>
                    </>
                  ) : (
                    <>
                      <span className={styles.price}>${plan.price}</span>
                      <span className={styles.period}>/month</span>
                    </>
                  )}
                </div>
              </div>
              
              <div className={styles.planFeatures}>
                <ul>
                  {plan.features.map((feature, index) => (
                    <li key={index}>
                      <span className={styles.checkmark}>✓</span>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
              
              <button
                className={styles.planButton}
                onClick={() => handleSignUp(plan)}
              >
                Sign Up Now
              </button>
            </div>
          ))}
          
          {/* Team License Card */}
          <div className={styles.planCard}>
            <div className={styles.planHeader}>
              <h3>Team License</h3>
              <p className={styles.planDescription}>Bulk Deal License (Billed Annually)</p>
              <div className={styles.planPrice}>
                <span className={styles.price}>$36.75</span>
                <span className={styles.period}>/month per user</span>
              </div>
            </div>
            
            <div className={styles.planFeatures}>
              <ul>
                <li>
                  <span className={styles.checkmark}>✓</span>
                  25 AI CMA Credits a month/user
                </li>
                <li>
                  <span className={styles.checkmark}>✓</span>
                  Unlimited Search
                </li>
                <li>
                  <span className={styles.checkmark}>✓</span>
                  Unlimited Map Search
                </li>
                <li>
                  <span className={styles.checkmark}>✓</span>
                  Unlimited MLS GPT
                </li>
                <li>
                  <span className={styles.checkmark}>✓</span>
                  Virtual Staging
                </li>
                <li>
                  <span className={styles.checkmark}>✓</span>
                  Video Montage from your Photos
                </li>
                <li>
                  <span className={styles.checkmark}>✓</span>
                  Access to all features
                </li>
                <li>
                  <span className={styles.checkmark}>✓</span>
                  Nationwide MLS Access
                </li>
                <li>
                  <span className={styles.checkmark}>✓</span>
                  Email Support
                </li>
              </ul>
            </div>
            
            <button
              className={styles.planButton}
              onClick={handleContactUs}
            >
              Contact Us
            </button>
          </div>
        </div>

        <a
          href="https://stripe.com"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.stripeBadge}
          aria-label="Powered by Stripe"
        >
          <img
            src="/powered-by-stripe.svg"
            alt="Powered by Stripe"
            width="150"
            height="34"
          />
        </a>

        {/* Bottom Banner */}
        <div className={styles.bottomBanner}>
          <div className={styles.bannerContent}>
            <h2>Start uncovering the power of AI today</h2>
            <p>Create comprehensive reports and understand your real estate landscape in minutes.</p>
            <button 
              className={styles.bannerButton}
              onClick={handleGetStarted}
            >
              Get Started
            </button>
          </div>
        </div>
      </div>
    </div>
    </PublicLayout>
  );
};

export default Pricing;
